import { render } from "./OrderTableCard.vue?vue&type=template&id=1329347d&scoped=true"
import script from "./OrderTableCard.vue?vue&type=script&lang=js"
export * from "./OrderTableCard.vue?vue&type=script&lang=js"

import "./OrderTableCard.vue?vue&type=style&index=0&id=1329347d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1329347d"]])

export default __exports__